export const transformAccountLivestreamIds = (formField) => {
  const type = formField?.type?.value;

  switch (type) {
    case 'Dedicated':
      return [
        {
          accountId: formField?.accountId?.value,
          studioId: formField?.studio?.value,
        },
      ];

    case 'Mirroring':
      const accountIds = Array.isArray(formField?.accountId) ? formField?.accountId : [formField?.accountId];
      return accountIds.map((account) => ({
        accountId: account?.value,
        studioId: formField?.studio?.value,
      }));

    case 'Cross-Platform':
      return [
        {
          accountId: formField?.accountId?.value,
          studioId: formField?.studio?.value,
        },
        {
          accountId: formField?.accountId2?.value,
          studioId: formField?.studio2?.value,
        },
      ].filter((item) => item?.accountId && item?.studioId);

    default:
      return [];
  }
};
